const getAge = ageString => {
  if (!ageString) return 'N.B'
  const fixedBirth = ageString.replace(/-/g, '')
  if (fixedBirth.length !== 8) return 'N.B'
  const userAge = {
    day: parseInt(fixedBirth.slice(0, 2)),
    month: parseInt(fixedBirth.slice(2, 4)),
    year: parseInt(fixedBirth.slice(4, 8))
  }
  const currentDateGetter = new Date()
  const currentDate = {
    day: currentDateGetter.getDate(),
    month: currentDateGetter.getMonth() + 1,
    year: currentDateGetter.getFullYear()
  }
  const ageBasedOnYear = currentDate.year - userAge.year
  if (userAge.month - currentDate.month > 0) return ageBasedOnYear - 1
  if (userAge.day - currentDate.day > 0) return ageBasedOnYear - 1
  return ageBasedOnYear
}

export { getAge }
